import React, { useState } from 'react';
import './NavBar.css'; // Create this CSS file to style the navigation bar
import logo from '../images/Screenshot_15-removebg-preview.jpg'; // Replace with your logo path
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const NavBar = () => {
  const [isMobile, setIsMobile] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobile(!isMobile);
  };

  return (
    <nav className="navbar">
      <div className="nav-content">
       <div className="logo-container">
  <Link to="/" onClick={() => setIsMobile(false)} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
    <img src={logo} alt="Logo" className="logo" />
    <span className="company-name">Pushkar Enterprises</span>
  </Link>
</div>

        <button className="mobile-menu-icon" onClick={toggleMobileMenu}>
          {isMobile ? <FaTimes /> : <FaBars />}
        </button>
        <ul className={isMobile ? "nav-menu mobile" : "nav-menu"}>
          <li onClick={toggleMobileMenu}><Link to="/">Home</Link></li>
          <li onClick={toggleMobileMenu}><Link to="/products">Products</Link></li>
          <li onClick={toggleMobileMenu}><Link to="/aboutus">About Us</Link></li>
          <li onClick={toggleMobileMenu}><Link to="/contactus">Contact Us</Link></li>
          
        <div className={isMobile ? "social-icons-Navbar mobile" : "social-icons-Navbar"} onClick={toggleMobileMenu}>
        <a onClick={toggleMobileMenu}href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
          <FaFacebookF className="social-icons-Navbar facebook" />
        </a>
        <a onClick={toggleMobileMenu}href="https://www.instagram.com/pushkarenterprises_/" target="_blank" rel="noopener noreferrer">
          <FaInstagram className="social-icons-Navbar instagram" />
        </a>
        <a onClick={toggleMobileMenu}href="https://x.com/puskhare" target="_blank" rel="noopener noreferrer">
          <FaTwitter className="social-icons-Navbar twitter" />
        </a>
        <a onClick={toggleMobileMenu}href="https://www.linkedin.com/ajaygirotra26" target="_blank" rel="noopener noreferrer">
          <FaLinkedinIn className="social-icons-Navbar linkedin" />
        </a>
      </div>
          
        </ul>
      </div>
      
    </nav>
  );
}

export default NavBar;
